import {
	currentUserMeetsUserLevel,
	UserLevel,
} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';
import {
	categoryPermissionChecker,
	PermissionName,
	PermissionMatrixName,
} from '@netx/core-permissions-next';
import {type ICategory} from '../schema';

export const canCreatePdfFromCategory = (
	category?: ICategory,
): category is ICategory => {
	if (category == null) return false;
	if (!currentUserMeetsUserLevel(UserLevel.CONSUMER)) return false;
	return categoryPermissionChecker({
		category,
		permissionMatrixName: PermissionMatrixName.DOWNLOAD,
		permissionName: PermissionName.DOWNLOAD,
	});
};
